import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import TimelineSection from './components/TimelineSection';
import SkillsEvolutionSection from './components/SkillsEvolutionSection';
import PersonalInsightsSection from './components/PersonalInsightsSection';
import CommunityImpactSection from './components/CommunityImpactSection';
import DownloadableResourcesSection from './components/DownloadableResourcesSection';

const AboutProfessionalStoryCenter = () => {
  useEffect(() => {
    // Set page title
    document.title = 'About - Professional Story Center | CodeShow LapZ';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Discover the journey behind CodeShow LapZ - from Sri Lankan engineering excellence to accomplished full-stack development. Explore Lahiru Senavirathna\'s professional timeline, technical evolution, and community contributions.');
    }

    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <HeroSection />
      
      {/* Professional Timeline */}
      <TimelineSection />
      
      {/* Skills Evolution */}
      <SkillsEvolutionSection />
      
      {/* Personal Insights */}
      <PersonalInsightsSection />
      
      {/* Community Impact */}
      <CommunityImpactSection />
      
      {/* Downloadable Resources */}
      <DownloadableResourcesSection />
    </div>
  );
};

export default AboutProfessionalStoryCenter;